module.exports = ":host{position:relative;display:flex;align-items:baseline;flex-direction:column}:host .versionsTooltip{position:absolute;left:185px}\n"